<template>
  <div
    class="shape"
    :style="style"
    @mousedown="handleMouseDown"
  >
    <div
      :key="point"
      :class="point"
      class="shape__point"
      v-for="point in shapePoints"
    >
    </div>
    <div class="shape__content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
// const PointSize = 16
export default {
  name: 'ICShape',
  props: {
    layer: {
      type: Object,
      default: () => ({})
    }
  },
  inject: ['moveLayer'],
  data () {
    return {
      shapePoints: ['l', 't', 'r', 'b', 'tl', 'tr', 'br','bl']
    }
  },
  computed: {
    style () {
      const { position: { x, y }, size: { width, height } } = this.layer
      return {
        left: x + 'px',
        top: y + 'px',
        width: width + 2 + 'px',
        height: height + 2 + 'px'
      }
    }
  },
  methods: {
    handleMouseDown (event) {
      event.stopPropagation()
      event.preventDefault()
      const { id, position: { x, y } } = this.layer
      this.moveLayer({ id, x, y })
    }
  }
}
</script>

<style lang="less">
@pointSize: 16px;
.shape {
  position: absolute;
  z-index: 900;
  width: 100%;
  background-color: grey;
  opacity: .6;
  height: 100%;
  border: 1px solid transparent;

  &:hover {
    border: 1px solid red;
  }

  &__point {
    position: absolute;
    width: @pointSize;
    height: @pointSize;
    border-radius: 50%;
    background-color: #ffffff;
    display: none;

    &:hover {
      border: 1px solid red;
    }

    &.l {
      top: calc(50% - @pointSize/2);
      left: calc(-@pointSize/2);
    }
    &.r {
      top: calc(50% - @pointSize/2);
      right: calc(-@pointSize/2);
    }
    &.t {
      top: calc(-@pointSize/2);
      left: calc(50% - @pointSize/2);
    }
    &.b {
      bottom: calc(-@pointSize/2);
      left: calc(50% - @pointSize/2);
    }
    &.tl {
      top: calc(-@pointSize/2);
      left: calc(-@pointSize/2);
    }
    &.tr {
      top: calc(-@pointSize/2);
      right: calc(-@pointSize/2);
    }
    &.bl {
      left: calc(-@pointSize/2);
      bottom: calc(-@pointSize/2);
    }
    &.br {
      right: calc(-@pointSize/2);
      bottom: calc(-@pointSize/2);
    }
  }

  &__content {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
  }
}
</style>
